// Este codigo fue generado por Github Copilot Chat
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Tab } from './tabType';

@Component({
  selector: 'app-tab',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabComponent {
  @Input() tabList!: Tab[];
  @Output() clickEmitter = new EventEmitter<number>();

  tabClick(position: number) {
    this.tabList = this.tabList.map((tab, i) => {
      return i === position
        ? { ...tab, isActive: true }
        : { ...tab, isActive: false };
    });

    this.clickEmitter.emit(position);
  }
}
// Este codigo fue generado por Github Copilot Chat
